import React from 'react';

export default class KeyValPair extends React.Component {
	static defaultProps = {
		val: '--',
		condensed: false,
		fullWidthOnEmpty: false,
	};

	render() {
		let { _key, val, condensed, fullWidthOnEmpty } = this.props;

		// safeguard to stop objects that were crashing the system.
		const isReactElement = (obj) =>
			obj && obj.$$typeof === Symbol.for('react.element');

		if (typeof val === 'object' && !isReactElement(val)) val = '--';

		const columnClassed = `${condensed ? 'm-0 py-1' : ''}`;

		// Check if value is empty (null, undefined, empty string, or empty JSX)
		const isEmpty =
			!val || val === '' || (typeof val === 'string' && val.trim() === '');

		return (
			<div
				data-testid={this.props['data-testid']}
				className={`block columns key-val ${
					this.props.striped ? 'striped' : ''
				}`}
			>
				{isEmpty && fullWidthOnEmpty ? (
					// When value is empty AND fullWidthOnEmpty is true, make key span full width
					<div className={`column is-full ${columnClassed}`}>
						<p className="m-0 is-size-7 has-text-weight-light">{_key}</p>
					</div>
				) : (
					// Normal two-column layout (always used when fullWidthOnEmpty is false)
					<>
						<div className={`column is-one-third ${columnClassed}`}>
							<p className="m-0 is-size-7 has-text-weight-light">{_key}</p>
						</div>
						<div className={`column ${columnClassed}`}>
							<p>{val}</p>
						</div>
					</>
				)}
			</div>
		);
	}
}
